import React from 'react';
import { useAuth } from '../App';

export default function Footer() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <footer style={styles.footer}>
      © {new Date().getFullYear()} Prof. Dr. Ömür Gökmen Sevindik. Tüm hakları saklıdır.
    </footer>
  );
}

const styles = {
  footer: {
    marginTop: 'auto',
    padding: '1rem 2rem',
    background: '#1e3a5f',
    color: '#cbd5e1',
    textAlign: 'center',
    fontSize: '0.85rem',
    borderTop: '1px solid #334155',
  },
};
